function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "191115_VF_Icon_calendar_NDN"), /*#__PURE__*/React.createElement("path", {
  d: "M212.5 14.5V7.3h-28.1v7.2H99.1V7.3H71v7.2H0v269h283.5v-269h-71zm42.8 241H28.1V106.7h227.2v148.8zm0-177.7H28.1V42.6H71v14.3h28.1V42.6h85.4v14.3h28.1V42.6h42.8v35.2h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7 202.1h26.8c1.2 5.6 7.9 10.6 21.8 10.6s20.4-5 20.4-13.9c0-9-6.6-14.2-21-14.2-12.8 0-18.1 4.1-20.5 6.8H98.5v-63.5h82.9v22h-57.2V168c5.9-2.9 14.4-4.5 24.1-4.5 28.4 0 41.5 14.1 41.5 35.4 0 24.4-17.4 35.9-47.6 35.9-32.2-.1-48-13.1-48.5-32.7z"
})));